<div class="copy">&copy; {{year}} {{ 'COPYRIGHT' | translate }}</div>
